// src/modules/app-views/ticket-events/pages/Document/actions/menuButton.js
import { MoreOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownNew,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';
import { showSaleTicketModal } from 'modules/app-views/ticketEvents/pages/Document/modals/SaleTicketModal';

const ticketEventsDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    dropdownItems: [
      dropdownNew,
      {
        key: 'saleTicket',
        label: 'sale_ticket',
        icon: <ShoppingCartOutlined />,
        disabled: ({ currentPage }) => !currentPage?.data?._id,
        onClick: ({ page, refreshDocument }) => {
          showSaleTicketModal({
            data: page?.data,
            onSuccess: () => refreshDocument?.(),
          });
        },
      },
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

export default ticketEventsDocumentMenuButton;
